import React from 'react';
import { Radio } from 'antd';
import './../styles.css';

const VehicleAnalyticsMenu = ({menuOptions, selectedMenu, onChangeMenu}) => {

    const onChangeOption = (e) => {
        onChangeMenu(e.target.value)
    }

    return (
        <Radio.Group
            options={menuOptions}
            onChange={onChangeOption}
            optionType="button"
            // defaultValue={selectedMenu}
            value={selectedMenu}
            buttonStyle="solid"
            className='vafirstradio valastradio'
        />
    )
}

export default VehicleAnalyticsMenu;